// Light and dark colors that code hands to charts and canvases, where CSS can't switch them.
// Read the current set from ThemeService.colors(). Keep the dark values in step with the
// --glimpse-* tokens in src/styles.scss (heatmapLow is --glimpse-card-bg, grid is --glimpse-divider...).
export interface ThemeColors {
  chart: {
    grid: string;
    tick: string;
    // Single-series line on a card (score trend).
    line: string;
    // Low end of the white-to-green heat maps; the high end is Colors.Compliant.
    heatmapLow: string;
    // Staffing context chart "Actual revenue" line.
    revenueLine: string;
    // Tasks performance "Median" lead-time line.
    medianLine: string;
    // Report indicators "average" bars.
    averageSeries: string;
  };
  // Good / middling / bad values written as text (staffing KPIs and forecast changes).
  kpi: {
    good: string;
    warning: string;
    bad: string;
  };
  // Auditing timeline grid (canvas).
  timeline: {
    missing: string;
    hover: string;
    current: string;
    cellBorder: string;
    minuteLine: string;
    gutter: string;
    minimap: string;
    knob: string;
    knobHover: string;
  };
}

export const LIGHT_COLORS: ThemeColors = {
  chart: {
    grid: '#f0f0f0',
    tick: '#666',
    line: '#1a237e',
    heatmapLow: 'white',
    revenueLine: '#0F6E56',
    medianLine: '#131a6b',
    averageSeries: '#3F468F',
  },
  kpi: {
    good: '#0F6E56',
    warning: '#854F0B',
    bad: '#A32D2D',
  },
  timeline: {
    missing: '#ccc',
    hover: '#ddd',
    current: '#333',
    cellBorder: '#88939A',
    minuteLine: '#333',
    gutter: '#ddd',
    minimap: '#F0F5FF',
    knob: 'white',
    knobHover: '#eee',
  },
};

export const DARK_COLORS: ThemeColors = {
  chart: {
    grid: '#3b3b41',
    tick: '#c7c5cd',
    line: '#9ba4ff',
    heatmapLow: '#1f1f25',
    revenueLine: '#4db6ac',
    medianLine: '#7986cb',
    averageSeries: '#7986cb',
  },
  kpi: {
    good: '#81c784',
    warning: '#ffb74d',
    bad: '#ef9a9a',
  },
  timeline: {
    missing: '#5e5e65',
    hover: '#46464d',
    current: '#e4e1ea',
    cellBorder: '#5e5e65',
    minuteLine: '#c7c5cd',
    gutter: '#292930',
    minimap: '#272a4a',
    knob: '#34343b',
    knobHover: '#46464d',
  },
};

// For places that hand a CSS color to the browser (style bindings, not chart/canvas APIs): light-dark()
// switches by itself, so these work without ThemeService - e.g. in store selectors.
export const CSS_THEME_COLORS = {
  // Admin matching chart connection lines.
  matchingConnection: {
    selected: 'light-dark(#000000, #e4e1ea)',
    other: 'light-dark(#cccccc, #5e5e65)',
  },
};
